import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";
import "./index.css";

let element = <App />;
let container = document.getElementById("root")
ReactDOM.render(element, container)